import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";


import Select from 'react-select';

const TrainingParticipateList = () => {

  const [schedules, setSchedules] = useState([]);


  useEffect(() => {
    fetchSchedules();
  }, []);

 const fetchSchedules = async () => {
  try {

    const res = await axios.get(
      `${API_BASE_URL}/training_list`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        }
      }
    );
console.log(res.data.data);
    setSchedules(res.data.data);

  } catch (error) {
    toast.error("Failed to load training schedules");
  }
};


const [errors, setErrors] = useState({});


const [locations, setLocations] = useState([]);

const [courses, setCourses] = useState([]);
const [topics, setTopics] = useState([]);

useEffect(() => {
  fetchSchedules();
}, []);








  return (
    <>
      <ToastContainer />

      <div className="container-fluid">

        {/* Header */}
        <div className="card-header d-flex justify-content-between">
  <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
    <i className="fa fa-calendar mr-2" style={{ fontSize: "20px" }} />
    List All Training Schedule
  </h3>

</div>










        {/* Table Card */}
        <div className="card">
           {/*<div className="card-header">
            <h6 className="card-title" style={{ color: "#e96827" }}>
              List All Training Schedule
            </h6>
          </div>*/}

          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-hover table-striped">
                <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Course</th>
                    <th>Topic</th>
                    <th>Location</th>
                    <th>Training Date</th>
                    <th>Training Time</th>
                    <th>PreTest</th>
                    <th>Training View Status</th>
                    <th>PostTest</th>
                    <th>Result</th>
                    <th>Feedback</th>
                  </tr>
                </thead>

                <tbody>
  {schedules.length > 0 ? (
    schedules.map((item, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
        <td>{item.course_name}</td>
        <td>{item.topic_name}</td>
        <td>{item.location_name}</td>
        <td>{new Date(item.training_date).toLocaleDateString()}</td>
        <td>{item.training_time}</td>
        <td>
  {item.pre_test_status === 0 ? (
    <Link to={`/PreTestExamQuiz/${item.id}/${item.question_count}`}>
      <button className="btn btn-xs btn-outline-info">
        <i class="fa-solid fa-lock-open"></i>
      </button>
    </Link>
  ) : (
    <button
      className="btn btn-xs btn-outline-success"
      onClick={() => alert("Pretest Already Completed")}
    >
      <i class="fa-solid fa-lock"></i>
    </button>
  )}
</td>

<td>
{
item.pre_test_status === 0 ? (

 <button
      className="btn icon-btn btn-sm btn-info postlock"
      onClick={() => alert("Kindly Finish Pre-test")}
    >
      <i class="fa-solid fa-lock"></i>
    </button>

) : item.pre_test_status === 1 && item.training_view_status === 0 ? (

<a href={`/ViewTopicDocument/${item.topic}/${item.id}`}>
<button
 className="btn icon-btn btn-xs btn-outline-info btn-outline-size-small"
 title="View Details"
>
<i class="fa-solid fa-lock-open"></i>
</button>
</a>

) : item.training_view_status === 1 ? (

<button
      className="btn icon-btn btn-sm btn-info postlock"
      onClick={() => alert("Training View Already Completed")}
    >
       <i class="fa-solid fa-lock"></i>
    </button>

) : null
}


</td>



<td>
{
item.pre_test_status === 0 || item.training_view_status === 0 ? (

<button
 className="btn icon-btn btn-sm btn-info postlock"
 onClick={() => alert("Complete Pre-test and View Training First")}
 
>
 <i class="fa-solid fa-lock"></i>
</button>

) : item.pre_test_status === 1 && 
     item.training_view_status === 1 && 
     item.post_test_status === 0 ? (

<Link to={`/PostTestExamQuiz/${item.id}/${item.question_count}`}>
      <button className="btn btn-xs btn-outline-info">
        <i class="fa-solid fa-lock-open"></i>
      </button>
    </Link>

) : item.post_test_status === 1 ? (

<button
 className="btn btn-xs btn-outline-success"
 onClick={() => alert("Post Test Already Completed")}
>
<i class="fa-solid fa-lock"></i>
</button>

) : null
}
</td>


<td>
{
item.pre_test_status === 1 && item.post_test_status === 1 ? (

<>
<Link to={`/PreTestReview/${item.id}`}>
  <button className="btn icon-btn btn-xs btn-outline-info">
    Pre-test Result
  </button>
</Link>

<Link to={`/PostTestReview/${item.id}`}>
  <button className="btn icon-btn btn-xs btn-outline-info">
    Post Test Result
  </button>
</Link>
</>

) : null
}
</td>


<td>

{
item.training_feedbacks === 0 && item.post_test_status === 1 ? (

<a href={`/FeedbackQuestion/${item.id}`}>
<button
 className="btn icon-btn btn-xs btn-outline-danger waves-effect btn-outline-size-small waves-light"
 title="View Details"
>
Feedback
</button>
</a>

) : item.training_feedbacks === 1 && item.post_test_status === 1 ? (

<button
 className="btn icon-btn btn-xs btn-outline-info btn-outline-size-small waves-effect waves-light"
 title="Feedback Completed"
>
Feedback Completed
</button>

) : null
}

</td>

      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="4" className="text-center">
        No Data Found
      </td>
    </tr>
  )}
</tbody>

              </table>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default TrainingParticipateList;